// React
import { useState } from "react";

// Components
import MultipleRoleLogin from "@Settings/Layouts/FormVariants/MultipleRoleLogin";
import ProviderLoginComponent from "@Settings/helpers/AdministrationTools/Provider/ProviderLoginComponent";

// Types
import { AuthenticationType, CapitalizedRoles } from "@Settings/types/Common/auth";
import { AuthRoleStatus, TSelectedProvider } from "@Settings/types/administrationTools/utils";

type DoubleStepLoginVariantProps = Readonly<{
	isError: boolean;
	error: Error | null;
	authType?: AuthenticationType;
	isLoading: boolean;
	disabled: boolean;
	selectedProvider: (Partial<TSelectedProvider> & { authRoleStatuses: AuthRoleStatus[] }) | null;
	// Callbacks
	onLogout?: (role: CapitalizedRoles) => void;
	onChangeProvider?: (provider: Partial<TSelectedProvider>) => void;
}>;

export default function DoubleStepLoginVariant(props: DoubleStepLoginVariantProps) {
	const { onLogout = () => {} } = props;

	// Local State
	const [showConfirmationElement, setShowConfirmationElement] = useState(false);
	const [selectedRole, setSelectedRole] = useState<CapitalizedRoles>("User");

	const authType = props.selectedProvider?.authRoleStatuses?.find((role) => role.role === selectedRole)?.authType ?? "basicAuth";

	const handleChangeComponent = (role: CapitalizedRoles) => {
		props.onChangeProvider?.({
			...props.selectedProvider,
			role,
			authType,
		});
		setShowConfirmationElement((prevState) => !prevState);
		setSelectedRole(role);
	};

	if (showConfirmationElement) {
		return <ProviderLoginComponent {...props} authType={authType} />;
	}

	return (
		<MultipleRoleLogin
			authRoleStatuses={props.selectedProvider?.authRoleStatuses ?? []}
			// Callbacks
			onLogin={handleChangeComponent}
			onLogout={onLogout}
		/>
	);
}
